<template>
  <div>
    <Modal v-model="printYunSkuModal" width="1000" :title="printYunSkuTitle">
      <Table
        highlight-row
        border
        max-height="490"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <template #footer>
        <Button type="primary" @click="printYunSkuModal = false">{{ $t('key1000248') }}</Button>
      </template>
    </Modal>
    <!--打印预览YMS面单弹窗-->
    <printPreviewWaybillModal
      :printPreviewWaybillTitle="printYunSkuTitle"
      ref="printPreviewWaybill"
      :printUrl="printUrl">
    </printPreviewWaybillModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/index';
import {printProductQRCode, setConfigCharacters} from "@/utils/common";
import printPreviewWaybillModal from "@/components/common/printPreviewWaybillModal.vue";

export default {
  name: 'printYunSkuModal',
  mixins: [Mixin],
  props: {
    // 是否是自营商品,默认为false 是供应商商品
    selfOperatedProducts: {
      type: Boolean,
      default: false
    },
    printUrl: {
      type: String,
      default: null
    }
  },
  data() {
    let v = this;
    return {
      printYunSkuModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
          key: 'pictureUrl',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            return v.tableImg(h, params, 'imagePath');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
          key: 'supplierSku',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let sku = params.row.supplierSku || params.row.sku;
            return h('span', sku);
          }
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000587'),
          minWidth: 130,
          render(h, params) {
            if (params.row.productGoodsSpecifications) {
              return h('div', {
                style: {
                  color: 'green'
                }
              }, params.row.productGoodsSpecifications.map(i => {
                return h('p', i.name + ':' + i.value);
              }));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          key: 'opts',
          width: 110,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003537'),
                    show: v.printType === 0,
                    clickFn: () => {
                      v.$refs['printPreviewWaybill'].initPrintPreviewWaybillData(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000595'),
                    show: v.printType === 1,
                    clickFn: () => {
                      let list = [{
                        productGoodsId: params.row.productGoodsId,
                        quantity: 1,
                        type: 1 // 0-条形码  1-二维码
                      }];
                      printProductQRCode(list).then((data) => {
                        if (data) {
                          v.commonPrint(data, '1');
                        }
                      })
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      printType: 0,
      printYunSkuTitle: '',
    };
  },
  methods: {
    getProductDetails(productId, printType, printTitle) {
      let v = this;
      v.tableLoading = true;
      v.printType = printType ? printType : 0;
      v.printYunSkuTitle = printTitle ? printTitle : (aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000320') + `${setConfigCharacters()}` + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000616'));
      let url = v.selfOperatedProducts ? api.get_ymsProductInfoCore : api.get_productInfo;
      v.axios.get(url + productId).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          this.tableData = data.productGoodsList.map(i => {
            i.imagePath = null;
            if (i.productGoodsImages) {
              i.imagePath = i.productGoodsImages[0].path;
            }
            return i;
          });
        }
        v.printYunSkuModal = true;
      });
    }
  },
  components: {
    printPreviewWaybillModal
  },
};
</script>

<style scoped>

</style>
